module.exports = __webpack_public_path__ + "static/media/final_image.40e2626f.png";